(() => {
  if (window.KeithCore) return;

  const focusableSelector = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled])',
    'select:not([disabled])', 'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let activeModal = null;
  let returnFocus = null;

  const getFocusable = root => [...root.querySelectorAll(focusableSelector)]
    .filter(element => !element.hidden && element.offsetParent !== null);

  function closeModal(modal = activeModal) {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('k2-scroll-locked');
    activeModal = null;
    if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
    returnFocus = null;
    modal.dispatchEvent(new CustomEvent('k2:modal:close', { bubbles: true }));
  }

  function openModal(modal, trigger) {
    if (!modal) return;
    if (activeModal && activeModal !== modal) closeModal(activeModal);
    activeModal = modal;
    returnFocus = trigger || document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('k2-scroll-locked');
    requestAnimationFrame(() => {
      const focusTarget = modal.querySelector('[data-k2-initial-focus]') || getFocusable(modal)[0];
      focusTarget?.focus();
    });
    modal.dispatchEvent(new CustomEvent('k2:modal:open', { bubbles: true }));
  }

  function onDocumentClick(event) {
    const opener = event.target.closest('[data-k2-modal-open]');
    if (opener) {
      const modal = document.getElementById(opener.dataset.k2ModalOpen);
      if (modal) {
        event.preventDefault();
        openModal(modal, opener);
      }
      return;
    }

    const closer = event.target.closest('[data-k2-modal-close]');
    if (closer) {
      event.preventDefault();
      closeModal(closer.closest('.k2-modal'));
    }
  }

  function onDocumentKeydown(event) {
    if (!activeModal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = getFocusable(activeModal);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onDocumentKeydown);

  window.KeithCore = { openModal, closeModal };
})();
